var defaultConfig = {
  qParam: 'q',
  qOverrideParam: 'q.override',
  qSuggestionsParam: 'q.suggestions',
  resultsPerPageParam: 'resultsPerPage',
  pageParam: 'page',
  maxSuggestions: 10,
  fieldsParam: 'fields'
};

export { defaultConfig };
//# sourceMappingURL=Config.esm.js.map
